import { NavLink } from 'react-router-dom'
import {
  LayoutDashboard,
  Users,
  Building2,
  Package,
  ShoppingCart,
  Menu,
  X,
  Shield,
  UserCircle,
  RefreshCw,
} from 'lucide-react'
import { useState } from 'react'
import { cn } from '../../utils/helpers'
import { useAuthStore } from '../../store/authStore'

const menuItems = [
  { icon: LayoutDashboard, label: 'Dashboard', path: '/dashboard' },
  { icon: Users, label: 'Clientes', path: '/clientes' },
  { icon: Building2, label: 'Indústrias', path: '/industrias' },
  { icon: Package, label: 'Produtos', path: '/produtos' },
  { icon: ShoppingCart, label: 'Pedidos', path: '/pedidos' },
]

const adminMenuItems = [
  { icon: Shield, label: 'Usuários', path: '/admin/usuarios', adminOnly: true },
]

const profileMenuItem = { icon: UserCircle, label: 'Meu Perfil', path: '/perfil' }

export function Sidebar() {
  const [isOpen, setIsOpen] = useState(false)
  const { user } = useAuthStore()
  const isAdmin = user?.role === 'admin'

  console.log('🔐 Sidebar - User role:', user?.role, '| isAdmin:', isAdmin)

  return (
    <>
      {/* Mobile menu button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="fixed top-4 left-4 z-50 p-2 rounded-lg bg-white dark:bg-gray-800 shadow-lg lg:hidden"
      >
        {isOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
      </button>

      {/* Overlay */}
      {isOpen && (
        <div
          className="fixed inset-0 z-40 bg-black/50 lg:hidden"
          onClick={() => setIsOpen(false)}
        />
      )}

      {/* Sidebar */}
      <aside
        className={cn(
          'fixed top-0 left-0 z-40 h-screen w-64 bg-white dark:bg-gray-800 border-r border-gray-200 dark:border-gray-700',
          'transition-transform duration-300 ease-in-out',
          'lg:translate-x-0',
          isOpen ? 'translate-x-0' : '-translate-x-full'
        )}
      >
        <div className="flex h-full flex-col">
          {/* Logo */}
          <div className="flex h-16 items-center justify-center border-b border-gray-200 dark:border-gray-700">
            <ShoppingCart className="h-8 w-8 text-primary-600" />
            <span className="ml-2 text-xl font-bold text-gray-900 dark:text-white">
              OrderSystem
            </span>
          </div>

          {/* Navigation */}
          <nav className="flex-1 overflow-y-auto p-4">
            <ul className="space-y-1">
              {menuItems.map((item) => (
                <li key={item.path}>
                  <NavLink
                    to={item.path}
                    onClick={() => setIsOpen(false)}
                    className={({ isActive }) =>
                      cn(
                        'flex items-center gap-3 rounded-lg px-4 py-3 text-sm font-medium transition-colors',
                        isActive
                          ? 'bg-primary-50 text-primary-700 dark:bg-primary-900/20 dark:text-primary-400'
                          : 'text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700'
                      )
                    }
                  >
                    <item.icon className="h-5 w-5" />
                    {item.label}
                  </NavLink>
                </li>
              ))}

              {/* Admin Menu */}
              {isAdmin && (
                <>
                  <li className="pt-4 pb-2">
                    <div className="px-4 text-xs font-semibold text-gray-400 dark:text-gray-500 uppercase tracking-wider">
                      Administração
                    </div>
                  </li>
                  {adminMenuItems.map((item) => (
                    <li key={item.path}>
                      <NavLink
                        to={item.path}
                        onClick={() => setIsOpen(false)}
                        className={({ isActive }) =>
                          cn(
                            'flex items-center gap-3 rounded-lg px-4 py-3 text-sm font-medium transition-colors',
                            isActive
                              ? 'bg-purple-50 text-purple-700 dark:bg-purple-900/20 dark:text-purple-400'
                              : 'text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700'
                          )
                        }
                      >
                        <item.icon className="h-5 w-5" />
                        {item.label}
                      </NavLink>
                    </li>
                  ))}
                </>
              )}

              {/* Profile Menu */}
              <li className="pt-4 pb-2">
                <div className="px-4 text-xs font-semibold text-gray-400 dark:text-gray-500 uppercase tracking-wider">
                  Conta
                </div>
              </li>
              <li>
                <NavLink
                  to={profileMenuItem.path}
                  onClick={() => setIsOpen(false)}
                  className={({ isActive }) =>
                    cn(
                      'flex items-center gap-3 rounded-lg px-4 py-3 text-sm font-medium transition-colors',
                      isActive
                        ? 'bg-blue-50 text-blue-700 dark:bg-blue-900/20 dark:text-blue-400'
                        : 'text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700'
                    )
                  }
                >
                  <profileMenuItem.icon className="h-5 w-5" />
                  {profileMenuItem.label}
                </NavLink>
              </li>
            </ul>
          </nav>

          {/* Footer */}
          <div className="border-t border-gray-200 p-4 dark:border-gray-700 space-y-3">
            <button
              onClick={() => {
                if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
                  navigator.serviceWorker.getRegistration().then(reg => {
                    if (reg) reg.update()
                  })
                }
                setTimeout(() => window.location.reload(), 800)
              }}
              className="flex w-full items-center justify-center gap-2 rounded-lg border border-gray-200 px-3 py-2 text-xs font-medium text-gray-600 hover:bg-gray-50 dark:border-gray-600 dark:text-gray-300 dark:hover:bg-gray-700"
            >
              <RefreshCw className="h-3.5 w-3.5" />
              Atualizar versão
            </button>
            <p className="text-xs text-center text-gray-500 dark:text-gray-400">
              © {new Date().getFullYear()} OrderSystem by SoftTech Cloud
            </p>
          </div>
        </div>
      </aside>
    </>
  )
}
